import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Company } from 'src/app/model/company';
import { User } from 'src/app/model/user';
import { AuthService } from 'src/app/services/auth.service';
import { CompaniesService } from 'src/app/services/companies.service';
import { AddDependeciesTestImageComponent } from '../../add-dependecies-test-image/add-dependecies-test-image.component';
import { TestImageDetailsDialogComponent } from '../../test-image-details-dialog/test-image-details-dialog.component';
import { PageEvent } from '@angular/material/paginator';
import {Tester} from "../../../model/tester";
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'aw-list-test-image',
  templateUrl: './list-test-image.component.html',
  styleUrls: ['./list-test-image.component.scss']
})
export class ListTestImageComponent implements OnInit {

  loggedUser: User;
  company?: Company;
  loading: boolean;
  dataSource: any[];
  displayedColumns = ['id', 'title', 'cia', 'stride', 'regulations', 'actions'];
  displayedColumnsVariations = ['testname', 'iface', 'target', 'description', 'actions']
  expandedVariations: any;
  companiesList: any[];
  companySelected: Company;
  testCounter: number;
  pageNumber = 1;
  pageSize = 15; 

  constructor(
    public dialog: MatDialog,
    private companyService: CompaniesService,
    private snackbar: MatSnackBar,
    private authService: AuthService
  ) {

  }

  ngOnInit(): void {

    this.loggedUser = this.authService.loggedUser();

    if (this.loggedUser.role === 'admin') {
      
      this.companyService.getAllCompanies().subscribe(response => {
        this.companiesList = response;
      })

    }
    else {
      const user = this.authService.loggedUser();
      if ('company' in user && user.company) {
        this.company = user.company;
        this.getTestImageListByCompany();
      }
    }

  }

  getTestImageListByCompany() {
    this.loading = true;
    this.companyService.getTestImages(this.company.id).subscribe(response => {
      let res = response as any;
      this.testCounter = res.count;
      if (res.count > 0)
        this.dataSource = response.data.testlist;
      else {
        this.dataSource = [];
      }
      this.loading = false;
    });
  }

  handlePageEvent(event: PageEvent) {
    this.loading = true;
    if (event.previousPageIndex < event.pageIndex)
      this.pageNumber++;
    else if (event.previousPageIndex > event.pageIndex)
      this.pageNumber--;
    this.pageSize = event.pageSize;
    this.companyService.getTestImages(this.company.id, this.pageNumber, this.pageSize).subscribe(response => {
      this.dataSource = response.data.testlist;
      this.loading = false;
    });
  }

  expandVariations(element: any): void {

    this.expandedVariations != element ?
      this.expandedVariations = element :
      this.expandedVariations = undefined;

  }

  deleteVariation(testid: string, scriptDescriptor: string) {

  let scriptid = testid + "_" + scriptDescriptor;

    this.companyService.deleteTestImageScriptDescriptors(this.company.id, scriptid).subscribe(response => {
      this.snackbar.open("Test deleted correctly!", 'Ok', {
            duration: 2000
          });

      // update image list 
      this.getTestImageListByCompany();       
    }, error => {
      this.snackbar.open("Test not deleted correctly!", 'Ok', {
        duration: 2000
      });
    });

  }

  addDependenciesTest(testID, scriptName: string) {
    this.dialog.open(AddDependeciesTestImageComponent,
      {
        data: {
          testid: testID,
          scriptName: scriptName,
          company: this.company
        }
      }
    )
  }

  details(test: any) {

    this.dialog.open(TestImageDetailsDialogComponent, {
      data: {
        test: test
      }
    });

  }

  checkCIA(element, letter: string): boolean {
    return element.cia.some(item => item[0].toLowerCase() === letter.toLowerCase());
  }
  getCIAArray() {
    return Array.from('CIA');
  }

  getSTRIDEArray() {
    return Array.from('STRIDE');
  }
  checkSTRIDE(element, letter: string): boolean {
    return element.stride.some(item => item[0].toLowerCase() === letter.toLowerCase());
  }

  getCIATooltip(element): string {
    const mappings = {
      'C': 'Confidentiality',
      'I': 'Integrity',
      'A': 'Availability'
    };

    return Object.keys(mappings).map(letter =>
      `${this.checkCIA(element, letter) ? '✓' : 'X'} ${mappings[letter]}`
    ).join('\n');

  }

  getSTRIDETooltip(element): string {
    const mappings = {
      'S': 'Spoofing',
      'T': 'Tampering',
      'R': 'Repudiation',
      'I': 'Information Disclosure',
      'D': 'Denial of Service',
      'E': 'Elevation of Privilege'
    };

    return Object.keys(mappings).map(letter =>
      `${this.checkSTRIDE(element, letter) ? '✓' : 'X'} ${mappings[letter]}`
    ).join('\n');
  }

  extractSLT(text: string): string | null {
    const match = text.match(/\((slt.\d+)\)/);
    return match ? match[1] : null;
  }

  extractTextUnece(text: string): string {
    const match = text.match(/^(.*?)(?=\s*\(slt.\d+\))/);
    return match ? match[1].trim() : text;
  }

}
